import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const WISHES_BASE = `${API_BASE_URL}/birthday-wishes`;

// Returns { total, isOpen, data } for the given year's card.
export const fetchBirthdayWishes = async (year) => {
  const res = await fetch(`${WISHES_BASE}?year=${encodeURIComponent(year)}`);
  return parseApiResponse(res);
};

export const submitBirthdayWish = async ({ name, message, website }) => {
  const res = await fetch(WISHES_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, message, website }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};
